import * as React from 'react';
import { Button } from '../../Button/Button';
import { ButtonType } from '../../Button/ButtonType.csharp';
import { SvgIcon } from '../../SvgIcon/SvgIcon';
import styles from './PaginationStatus.module.css';

export interface BasePaginationStatusTranslations {
    showMore: string;
    error: string;
    searching: string;
    noResultsFound: string;
}

export interface PaginationStatusWithRetryTranslations extends BasePaginationStatusTranslations {
    tryAgain: string;
}

interface BasePaginationStatusProps {
    hasError: boolean;
    loading: boolean;
    hasMoreData: boolean;
    loadMoreData: VoidFunction;
    hasNoResults: boolean;
}

interface PaginationStatusWithRetryProps extends BasePaginationStatusProps {
    translations: PaginationStatusWithRetryTranslations;
    allowRetry: true;
}

interface PaginationStatusWithoutRetryProps extends BasePaginationStatusProps {
    translations: BasePaginationStatusTranslations;
    allowRetry?: false;
}

export type PaginationStatusProps = PaginationStatusWithRetryProps | PaginationStatusWithoutRetryProps;

export const PaginationStatus: React.FC<React.PropsWithChildren<PaginationStatusProps>> = props => {
    const { loading, hasError, allowRetry, hasMoreData, loadMoreData, hasNoResults, translations } = props;

    return (
        <div className={styles.PaginationStatus}>
            {loading || hasError || hasNoResults ? (
                <>
                    {loading && <p role="status">{translations.searching}</p>}
                    {hasError && (
                        <>
                            <p role="status">{translations.error}</p>
                            {allowRetry && hasMoreData && (
                                <Button onClick={loadMoreData} type={ButtonType.Clear} className={styles.StatusButton}>
                                    <span>{translations.tryAgain}</span>
                                </Button>
                            )}
                        </>
                    )}
                    {hasNoResults && <p role="status">{translations.noResultsFound}</p>}
                </>
            ) : (
                hasMoreData && (
                    <Button onClick={loadMoreData} type={ButtonType.Clear} className={styles.StatusButton}>
                        <span>{translations.showMore}</span>
                        <SvgIcon iconName="chevron-right" className={styles.DownArrow} />
                    </Button>
                )
            )}
        </div>
    );
};
